import React from 'react'

function StarMark() {
    return (
        <>
            <sup>
                <i className="fas fa-asterisk ml-2" style={{ color: '#ff0000ba', fontSize: '8px' }} />
            </sup>
        </>
    )
}

export default StarMark
